
const styles = theme => ({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
      width: '100%',
    },
    formControl: {
    //   margin: theme.spacing(1),
      width: '100%',
    },
    chips: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    chip: {
      margin: theme.spacing(0.25),
    },
    noLabel: {
      marginTop: theme.spacing(3),
    },
});
  
export {styles}